import { configureStore } from "@reduxjs/toolkit";
import Location from "./reducers/Location";
import CounterBadge from "./reducers/CounterBadge";
import User from "./reducers/User";
import GlobalSearch from "./reducers/GlobalSearch";
import AuthReducer from "./reducers/Tokens";
import TableFilter from "./reducers/TableFilter";

export const store = configureStore({
	reducer: {
		badge: CounterBadge,
		location: Location,
		user: User,
		globalSearch: GlobalSearch,
		authReducer: AuthReducer,
		tableFilter: TableFilter,
	},
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
